import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import RequestItemIndexPage from '../containers/RequestItems'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const RequestItemsPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'request_items') {
			dispatch(changeCurrent(['request_items']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={RequestItemIndexPage} exact />
		</Switch>
  )
}

RequestItemsPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

RequestItemsPage.defaultProps = {}

export default RequestItemsPage
